"use strict";
exports.__esModule = true;
exports.INCOME_VERIFICATION_BANK_LINK = void 0;
exports.INCOME_VERIFICATION_BANK_LINK = {
    HEADER: 'Verify your income',
    BODY: 'We’ll use Plaid to connect to your bank account, and verify your annual income of ${{incomeAmount}}.',
    REQUIREMENTS_HEADER: 'Bank account requirements',
    REQUIREMENTS_BULLETS: [
        'Must be the account where your income is deposited',
        'Name on account must match the name given to Flex',
        'Personal accounts only, no business accounts',
    ],
    PAYSTUB: 'Need to verify a different way? ',
    PAYSTUB_LINK: 'Upload paystubs',
    CTA: 'Continue to connect'
};
